<div class="text-card" [ngClass]="'text-card--' + spacing">
  <ng-content></ng-content>
</div>
